__turbopack_context__.v({
  "search-pagination": "search-pagination-module-scss-module__W0zLWG__search-pagination",
});
